/** Shared Recharts styling that follows the light/dark theme through CSS variables. */
export const CHART_TOOLTIP = {
  contentStyle: {
    backgroundColor: 'hsl(var(--card))',
    border: '1px solid hsl(var(--border))',
    borderRadius: '8px',
    fontSize: '12px',
    color: 'hsl(var(--foreground))',
  },
  labelStyle: { color: 'hsl(var(--foreground))', fontWeight: 600 },
  itemStyle: { color: 'hsl(var(--foreground))' },
  cursor: { fill: 'hsl(var(--accent))', opacity: 0.5 },
};

export const AXIS_TICK = { fontSize: 12, fill: 'hsl(var(--muted-foreground))' };

export const SERIES_COLORS = ['#6366f1', '#14b8a6', '#f59e0b', '#ec4899', '#8b5cf6', '#06b6d4', '#ef4444', '#84cc16', '#0ea5e9', '#d946ef'];

/** "$1.2k" style ticks. */
export function compactUsd(value: number): string {
  const abs = Math.abs(value);
  if (abs >= 1_000_000) return `$${(value / 1_000_000).toFixed(1)}M`;
  if (abs >= 1_000) return `$${(value / 1_000).toFixed(abs >= 10_000 ? 0 : 1)}k`;
  return `$${Math.round(value)}`;
}
